import react, { useEffect, useState } from "react";
import { CiDark, CiLight, CiMonitor } from "react-icons/ci";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../Translations/LenguageContext";

const APPEARANCE_OPTIONS = [
    { value: "system", label: "System" },
    { value: "light", label: "Light" },
    { value: "dark", label: "Dark" },
];

const Sidebar = ({ sidebarOpen, setSelectedLink, selectedLink }) => {
    const {t} = useLanguage()
    const navigate = useNavigate()
    const [showAppearance, setShowAppearance] = useState(false);
    const [appearance, setAppearance] = useState(() => {
        return localStorage.getItem("pe8-theme-preference") || "system";
    });

    // useEffect(() => {
    //     const root = window.document.documentElement;

    //     const applyTheme = (theme) => {
    //         let themeToSet = theme;

    //         if (theme === "system") {
    //             const systemTheme = window.matchMedia("(prefers-color-scheme: dark)").matches
    //                 ? "dark"
    //                 : "light";
    //             themeToSet = systemTheme;
    //         }

    //         root.setAttribute("data-theme", themeToSet);
    //         localStorage.setItem("pe8-theme-preference", theme);
    //     };

    //     applyTheme(appearance);

    //     if (appearance === "system") {
    //         const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    //         const handleChange = () => applyTheme("system");

    //         mediaQuery.addEventListener("change", handleChange);
    //         return () => mediaQuery.removeEventListener("change", handleChange);
    //     }
    // }, [appearance]);


    return (
        <div className={`sidebar_home ${sidebarOpen ? "sidebar_home_open" : "sidebar_home_closed"}`}>
            <div className="sidebar_home_inner">
                <p className={`sidebar_home_links ${selectedLink == 1 ? "sidebar_home_links_selected" : ""}`} onClick={() => setSelectedLink(1)}>Project E8</p>
                <p className={`sidebar_home_links ${selectedLink == 2 ? "sidebar_home_links_selected" : ""}`} onClick={() => setSelectedLink(2)}>{t.website.sidebar.abilities}</p>
                <p className={`sidebar_home_links ${selectedLink == 3 ? "sidebar_home_links_selected" : ""}`} onClick={() => setSelectedLink(3)}>{t.website.sidebar.fine_tuning}</p>
                <p className={`sidebar_home_links ${selectedLink == 4 ? "sidebar_home_links_selected" : ""}`} onClick={() => setSelectedLink(4)}>{t.website.sidebar.team_managment}</p>
                <p className="sidebar_home_links" onClick={() => navigate("/pricing")}>{t.website.sidebar.pricing}</p>
                {/* <p className="sidebar_home_links" onClick={() => navigate("/docs")}>Docs</p> */}
                {/* <p className={`sidebar_home_links ${selectedLink == 5 ? "sidebar_home_links_selected": ""}`} onClick={()=> setSelectedLink(5)}>Use cases</p> */}
            </div>
            {/* <div className="sidebar_theme_cont_theme">
                <div className="sidebar_theme_cont">
                    <div className="sidebar_theme_toggle_cont">
                        <button className={`sidebar_theme_toggle_btn ${appearance == "light" ? "sidebar_theme_toggle_btn_selected" : ""}`} onClick={() => {
                            setAppearance("light");
                            setShowAppearance(false);
                        }}><CiLight /></button>

                        <button className={`sidebar_theme_toggle_btn ${appearance == "dark" ? "sidebar_theme_toggle_btn_selected" : ""}`} onClick={() => {
                            setAppearance("dark");
                            setShowAppearance(false);
                        }}><CiDark /></button>

                        <button className={`sidebar_theme_toggle_btn ${appearance == "system" ? "sidebar_theme_toggle_btn_selected" : ""}`} onClick={() => {
                            setAppearance("system");
                            setShowAppearance(false);
                        }}><CiMonitor /></button>


                    </div>
                </div>
            </div> */}
        </div>
    )
}

export default Sidebar